<template>
  <div>
    <News />
  </div>
</template>
